export const AUTHOR_FORM_LINK =
  "https://docs.google.com/forms/d/e/1FAIpQLSdfF_mKbgUqXQ1wNzkmmjGrqaODH0es--S9W-V2RY26xm2fkQ/viewform?usp=sharing&ouid=111814169704048303777";
export const SPECIMEN_FORM_LINK =
  "https://docs.google.com/forms/d/e/1FAIpQLSe63PzG_olnqrVktAmCFTnqWiRxMyDCJXk0CIFdFb4NY4k-MQ/viewform?usp=sharing&ouid=111814169704048303777";
export const CATALOGUE_LINK =
  "https://docs.google.com/spreadsheets/d/1mat_2KD33aFq9_8PygAtA4qlKXL0izwq6JSd0TsVEOw/edit?usp=sharing";
export const ORDER_FORM_LINK =
  "https://docs.google.com/forms/d/e/1FAIpQLScdi3CF7BHfHOdRRZx1IiNpA4UN0xe5PP7800AywCumxOTmgA/viewform?usp=sharing&ouid=111814169704048303777";
